import _ from 'lodash'
import { Becy } from '@/components/ui/icon'
import { HorizontalCarousel } from '@/components/casino/lobby/carousel/HorizontalCarousel'
import { OriginalGameCard } from '@/components/original/OriginalGameCard'
import { OriginalGameCardSkeleton } from '@/components/original/OriginalGameCardSkeleton'
import { getSortedOriginalGames } from '@/lib/original-games'
import type { OriginalGame } from '@/types/original'
import { ORIGINAL_SKELETON_COUNT } from '@/config/original'

interface OriginalsSectionProps {
	games: OriginalGame[]
	isLoading?: boolean
	isError?: boolean
}

export function OriginalsSection({ games, isLoading = false, isError = false }: OriginalsSectionProps) {
	const activeGames = getSortedOriginalGames(games)

	return (
		<section className='flex min-w-0 flex-col gap-4'>
			<div className='flex items-center gap-3'>
				<Becy className='h-7 w-7 text-primary' />
				<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>BECY Originals</h2>
			</div>

			{isError ? <p className='text-sm text-muted-foreground'>Unable to load original games right now.</p> : null}

			{isLoading ? (
				<div className='flex gap-6 overflow-x-auto px-[5px] pb-8 pt-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
					{_.times(ORIGINAL_SKELETON_COUNT, (index) => (
						<OriginalGameCardSkeleton key={`original-game-skeleton-${index}`} />
					))}
				</div>
			) : null}

			{!isLoading && !isError ? (
				<HorizontalCarousel>
					{_.map(activeGames, (game) => (
						<OriginalGameCard key={game.id} game={game} />
					))}
				</HorizontalCarousel>
			) : null}
		</section>
	)
}
